module.exports = __webpack_public_path__ + "static/assets/11da4dd5aed8d16c4c53ebb657bc871a.png";